import { ErrorBuilder, SchemaErrors } from 'src/utils/validation';

export interface RegistrationReoSchema {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  organization_name: string;
  vat_identifier: string;
  city: string | null;
  password: string;
  consent_marketing: boolean;
  consent_reo_analytics: boolean;
}

export type FormErrors = SchemaErrors<RegistrationReoSchema>;

const firstPageFieldsRequired: (keyof RegistrationReoSchema)[] = [
  'first_name',
  'last_name',
  'email',
  'phone_number',
  'organization_name',
  'vat_identifier',
  'city',
];

export const firstPageFields: (keyof RegistrationReoSchema)[] = [
  ...firstPageFieldsRequired,
  'consent_reo_analytics',
];

const applyFirstPageValidation = (
  data: RegistrationReoSchema,
  builder: ErrorBuilder<RegistrationReoSchema>
) => {
  const digitsOnlyRegex = /^\d+$/;

  builder
    .checkEmail(['email'], 'registration_bnp:emailError')
    .checkTruthy(firstPageFieldsRequired, 'validation.required')
    .checkRule(
      ['vat_identifier'],
      (value) => value.length === 10 && digitsOnlyRegex.test(value),
      'registration_bnp:vatIdentifierError'
    );
};

const applySecondPageValidation = (
  data: RegistrationReoSchema,
  builder: ErrorBuilder<RegistrationReoSchema>
) => {
  builder.checkTruthy(['password'], 'validation.required');
};

export const validateForm = (data: RegistrationReoSchema): FormErrors => {
  const builder = new ErrorBuilder(data);
  applyFirstPageValidation(data, builder);
  applySecondPageValidation(data, builder);
  return builder.build();
};

export const validateFormFirstPage = (
  data: RegistrationReoSchema
): FormErrors => {
  const builder = new ErrorBuilder(data);
  applyFirstPageValidation(data, builder);
  return builder.build();
};
